import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const lang = localStorage.getItem('lang') || 'en';

//create a new customer
export const createCustomer = async (payload) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/customer/create-customer`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Create Customer API Error:", error);
    throw error;
  }
};

// Fetch all customers
export const getAllCustomers = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/customer/customer-list`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Accept-Language': lang
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get Customers API Error:", error);
    throw error;
  }
};

// Update a customer
export const updateCustomer = async (id, payload) => {
  try {
    const response = await api.put(`${API_BASE_URL}api/customer/${id}`, payload, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": lang,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Update Customer API Error:", error);
    throw error;
  }
};


export const deleteCustomerApi = async (id) => {
  const response = await api.delete(`${API_BASE_URL}api/customer/${id}`);
  return response.data;
};


// New

// // api/customer.js
// import { api } from "./client";

// const RAW_BASE = process.env.REACT_APP_API_BASE_URL || "";
// // Ensure exactly one trailing slash: "" -> "", "https://x" -> "https://x/", "https://x/" -> "https://x/"
// const API_BASE = RAW_BASE.replace(/\/?$/, RAW_BASE ? "/" : "");

// // Helpers
// const getLang = () => (localStorage.getItem("lang") === "ar" ? "ar" : "en");
// const getToken = () => localStorage.getItem("token") || "";
// const getStoreId = () => localStorage.getItem("storeId") || "";

// /**
//  * Build standard headers.
//  * - Adds JSON content-type when json=true
//  * - Adds Authorization if token exists
//  * - Adds Accept-Language
//  * - Adds X-Store-Id if available (for multi-tenant resolution on backend)
//  */
// function buildHeaders({ json = false } = {}) {
//   const headers = {
//     "Accept-Language": getLang(),
//   };

//   const token = getToken();
//   if (token) headers["Authorization"] = `Bearer ${token}`;

//   const storeId = getStoreId();
//   if (storeId) headers["X-Store-Id"] = storeId;

//   if (json) headers["Content-Type"] = "application/json";
//   return headers;
// }

// /**
//  * Extract a readable message from backend i18n format:
//  * backend often returns: message: [{ en: "..." }, { ar: "..." }]
//  */
// function extractI18nMessage(err) {
//   try {
//     const lang = getLang();
//     const msg = err?.response?.data?.message;
//     if (Array.isArray(msg)) {
//       // find the object that has our lang key
//       const found = msg.find((m) => m && typeof m === "object" && m[lang]);
//       if (found && found[lang]) return String(found[lang]);
//       // fallback: first available value
//       const any = msg.find((m) => m && typeof m === "object");
//       if (any) return Object.values(any)[0];
//     }
//     // plain string fallback
//     if (typeof msg === "string") return msg;
//   } catch (_) {
//     /* no-op */
//   }
//   return null;
// }

// function rethrowWithNiceMessage(prefix, error) {
//   const serverMsg = extractI18nMessage(error);
//   if (serverMsg) {
//     error.friendlyMessage = `${prefix}: ${serverMsg}`;
//   } else if (error?.message) {
//     error.friendlyMessage = `${prefix}: ${error.message}`;
//   } else {
//     error.friendlyMessage = prefix;
//   }
//   throw error;
// }

// // ---------- API CALLS ----------

// // Create a new customer
// export const createCustomer = async (payload = {}) => {
//   try {
//     // Avoid vendor spoofing: let the backend stamp vendorStoreId
//     const { ...rest } = payload;

//     // If you DON’T have storeId in localStorage, backend can also read it from the body.
//     // Only add storeId to body when we don’t have it in headers.
//     const storeId = getStoreId();
//     const body = { ...rest };
//     if (!storeId && !body.storeId && localStorage.getItem("storeId")) {
//       body.storeId = localStorage.getItem("storeId");
//     }

//     const res = await api.post(
//       `${API_BASE}api/customer/create-customer`,
//       body,
//       { headers: buildHeaders({ json: true }) }
//     );
//     // Backend returns: { success, message: [{en},{ar}], data }
//     return res.data;
//   } catch (error) {
//     console.error("Create Customer API Error:", error);
//     rethrowWithNiceMessage("Failed to create customer", error);
//   }
// };

// // Fetch all customers (backend returns an array of formatted customers)
// export const getAllCustomers = async () => {
//   try {
//     const res = await api.get(`${API_BASE}api/customer/customer-list`, {
//       headers: buildHeaders(),
//     });
//     return res.data; // array
//   } catch (error) {
//     console.error("Get Customers API Error:", error);
//     rethrowWithNiceMessage("Failed to fetch customers", error);
//   }
// };

// // Update a customer
// export const updateCustomer = async (id, payload = {}) => {
//   try {
//     const res = await api.put(`${API_BASE}api/customer/${id}`, payload, {
//       headers: buildHeaders({ json: true }),
//     });
//     // Backend returns: { message: [{en},{ar}] }
//     return res.data;
//   } catch (error) {
//     console.error("Update Customer API Error:", error);
//     rethrowWithNiceMessage("Failed to update customer", error);
//   }
// };

// // Delete a customer
// export const deleteCustomerApi = async (id) => {
//   try {
//     const res = await api.delete(`${API_BASE}api/customer/${id}`, {
//       headers: buildHeaders(),
//     });
//     // Backend returns: { message: [{en},{ar}] }
//     return res.data;
//   } catch (error) {
//     console.error("Delete Customer API Error:", error);
//     rethrowWithNiceMessage("Failed to delete customer", error);
//   }
// };
